import { Injectable } from '@angular/core';

@Injectable()
export class HttpHelperService {
  //class getters
  //access DOM to determine http info: server hostname (localhost or digitalocean), protocol (http/https), and combined baseurl
  get hostname():string { return window.location.hostname as string }
  get protocol():string { return this.hostname == "localhost" ? "http://" : "https://" }
  get baseUrl():string { return this.protocol + this.hostname};

  constructor() { }

  urlFromPath(path:string){
    // console.log('requesting: '+this.baseUrl+path);
    return this.baseUrl + path;
  }
  
  
}



// WEBPACK FOOTER //
// ./src/app/services/utility/http-helper.service.ts